import { render, staticRenderFns } from "./Magazzino.vue?vue&type=template&id=807d649c&scoped=true&"
import script from "./Magazzino.vue?vue&type=script&lang=js&"
export * from "./Magazzino.vue?vue&type=script&lang=js&"
import style0 from "./Magazzino.vue?vue&type=style&index=0&id=807d649c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807d649c",
  null
  
)

export default component.exports